import React, { useState } from 'react';
import Statblocker from './Statblocker'; 
import bearfolkData from './bearfolk.json';

const StatblockViewer = () => {
  const [monsterData, setMonsterData] = useState(bearfolkData);
  
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        setMonsterData(data);
      } catch (error) {
        console.error('Error parsing JSON file:', error);
        alert('Invalid JSON file');
      }
    };
    reader.readAsText(file);
  };

  return (
    <div className="statblock-viewer">
      <h1 style={{ textAlign: 'center' }}>OM Stat Block Viewer</h1>
      
      <div style={{ 
        textAlign: 'center', 
        margin: '20px auto', 
        maxWidth: '600px' 
      }}>
        <h3>Load Monster Data</h3>
        <div style={{ margin: '15px auto' }}>
          <label htmlFor="file-upload">Upload .json file: </label>
          <input type="file" id="file-upload" onChange={handleFileUpload} accept=".json,.monster" />
        </div>
      </div>
      
      <div style={{ 
        textAlign: 'center', 
        margin: '30px auto',
        maxWidth: '600px'
      }}>
        <h2>Monster Stat Block</h2>
        <Statblocker monsterData={monsterData} />
      </div>
    </div>
  );
};

export default StatblockViewer;